@for (option of options; track option.id) {
  <div class="vat-row">
    <strong>{{ option.kind === 'reverse_charge' ? ('invoicing.vat.reverse_charge' | translate) : ('invoicing.vat.rate' | translate:{value: option.rate}) }}</strong>
    <span class="printed">{{ option.printed_text }}</span>
    @if (option.in_use) {
      <span class="hint in-use" tabindex="0" [nbTooltip]="'invoicing.vat.in_use_explain' | translate" [attr.aria-label]="'invoicing.vat.in_use_explain' | translate">{{ 'invoicing.vat.in_use' | translate }}</span>
    } @else {
      <button nbButton ghost size="tiny" status="danger" [disabled]="busy" (click)="remove(option)">{{ 'invoicing.vat.delete' | translate }}</button>
    }
  </div>
} @empty {
  <p class="hint">{{ 'invoicing.vat.none' | translate }}</p>
}
<div class="add-row">
  <nb-select size="small" [attr.aria-label]="'invoicing.vat.kind' | translate" [(selected)]="draft.kind">
    <nb-option value="standard">{{ 'invoicing.vat.standard' | translate }}</nb-option>
    <nb-option value="reverse_charge">{{ 'invoicing.vat.reverse_charge' | translate }}</nb-option>
  </nb-select>
  @if (draft.kind === 'standard') {
    <nb-select size="small" [attr.aria-label]="'invoicing.vat.rate_label' | translate" [status]="errors.rate ? 'danger' : 'basic'" [(selected)]="draft.rate">
      @for (rate of rates; track rate) { <nb-option [value]="rate">{{ rate }}%</nb-option> }
    </nb-select>
    <input nbInput fieldSize="small" maxlength="255" [status]="errors.text ? 'danger' : 'basic'" [(ngModel)]="draft.text" [placeholder]="'invoicing.vat.text' | translate" [attr.aria-label]="'invoicing.vat.text' | translate">
  }
  <button nbButton size="small" status="primary" [disabled]="busy" (click)="add()"><nb-icon icon="plus-outline"></nb-icon><span>{{ 'invoicing.vat.add' | translate }}</span></button>
</div>
@for (message of errorList(); track message) { <p class="error">{{ message }}</p> }
